import React, { useState } from 'react'
import Nlayout from '../layout/Nlayout'
import { Grid } from '@mui/material'
import axios from 'axios';
import ReactGA from 'react-ga4';
import config from '../../config';
import ReCAPTCHA from 'react-google-recaptcha';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';

function Crear(props) {
    const [formData, setFormData] = useState({
        username: '',
        email: '',
        password: '',
        confirmPassword: ''
    });
    const [secretKey, setSecretKey] = useState("");
    const [errorUserName, setErrorUserName] = useState(null);
    const [errorPassword, setErrorPassword] = useState(null);
    const [errorConfirmPassword, setErrorConfirmPassword] = useState(null);
    const [errorEmail, setErrorEmail] = useState(null);
    const [recaptchaToken, setRecaptchaToken] = useState(null);
    const [qrCodeUrl, setQrCodeUrl] = useState('');
    const [twoFACode, setTwoFACode] = useState(''); // Código 2FA
    const [showTwoFAStep, setShowTwoFAStep] = useState(false); // Mostrar QR y campo 2FA
    const [twoFAError, setTwoFAError] = useState(''); // Error para 2FA

    const createSecret = (secretLength = 16) => {
        const charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"; // Base32
        let secret = "";
        for (let i = 0; i < secretLength; i++) {
            const randomIndex = Math.floor(Math.random() * charset.length);
            secret += charset[randomIndex];
        }
        return secret;
    };




    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'password' && value.length > 10) {
            return;
        }
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };
    const validarCampos = () => {
        const errores = {};
        if (!formData.email || !/^\S+@\S+\.\S+$/.test(formData.email)) {
            errores.email = 'El email es inválido';
        }
        if (!formData.username || !/^[a-zA-Z0-9]{4,10}$/.test(formData.username)) {
            errores.username = 'La cuenta debe tener entre 4 y 10 caracteres alfanuméricos';
        }
        if (!formData.password || !/^[a-zA-Z0-9~!#$%&*-_+=|:.]{6,10}$/.test(formData.password)) {
            errores.password = 'La contraseña debe tener entre 6 y 10 caracteres y solo puede contener números, letras y los siguientes caracteres: ~ ! # $ % & * - _ + = | : .';
        }
        if (formData.password !== formData.confirmPassword) {
            errores.confirmPassword = 'Las contraseñas no coinciden';
        }
        return errores;
    };
    const handleRegister = async () => {
        try {
          const requestData = {
            email: formData.email,
            account: formData.username,
            password: formData.password,
            auth_secret: secretKey
          };
          const response = await axios.post(`${config.apiBaseUrl}/registronuevo`, requestData);
          if (response.data === true) {
            ReactGA.event({
              category: 'User',
              action: 'Created an Account'
            });
            
          } 
          window.location.href = "/authenticate";

        } catch (error) {
          
        }
      };
    const handleCreateAccount = async () => {
        // Validar campos
        const errores = validarCampos();
        if (Object.keys(errores).length > 0) {
            setErrorUserName(errores.username || '');
            setErrorEmail(errores.email || '');
            setErrorPassword(errores.password || '');
            setErrorConfirmPassword(errores.confirmPassword || '');
            return;
        }

        if (!recaptchaToken) {
            setErrorUserName('Por favor, completa el reCAPTCHA');
            return;
        }

        try {
            // Verificar si la cuenta ya existe
            const response = await fetch(`${config.apiBaseUrl}/verificar`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    account: formData.username,
                }),
            });
            const data = await response.json();
            if (data.exists) {
                setErrorUserName('La cuenta ya existe');
                return;
            }

            // Generar secreto y QR
          await handleRegister();
            
        } catch (error) {
            console.error('Error:', error);
            setErrorUserName('Error al procesar la solicitud');
        }
    };

    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    const onChangeConfirmPassword = (e) => {
        const { value } = e.target;
        if (value.length > 10) {
            return;
        }
        setFormData(prevState => ({
            ...prevState,
            confirmPassword: value
        }));
    };
    return (
        <Nlayout tyExpanded={props.tyExpanded} setExpanded={props.setExpanded} isMobile={props.isMobile}>
            <Grid style={{ display: 'flex', flexDirection: 'column', gap: 15, marginTop: 10, padding: 15, borderRadius: 5, boxShadow: '0 2px 4px rgba(0,0,0,0.1)', width: '100%' }}>
                <div className="auth-content">
                    <div className="auth-content-input">
                        <p style={{ fontSize: '12px', fontFamily: 'inter', color:'black' }}>Email*</p>
                        <input
                            className={errorEmail && "input-error"}
                            value={formData.email}
                            onChange={handleChange}
                            name="email"
                            type="text"
                        />
                        {errorEmail && <p style={{ fontSize: "10px", color: "rgb(228, 122, 122)", marginTop: "5px" }}>{errorEmail}</p>}
                    </div>
                    <div className="auth-content-input">
                        <p style={{ fontSize: '12px', fontFamily: 'inter', color:'black' }}>Cuenta*</p>
                        <input
                            className={errorUserName && "input-error"}
                            name="username"
                            value={formData.username}
                            onChange={handleChange}
                            type="text"
                        />
                        {errorUserName && <p style={{ fontSize: "12px", color: "rgb(228, 122, 122)", marginTop: "5px", fontFamily: 'inter', color:'black' }}>{errorUserName}</p>}
                    </div>
                    <div className="auth-content-input">
                        <p style={{ fontSize: '12px', fontFamily: 'inter' , color:'black'}}>Contraseña*</p>
                        <div style={{ position: 'relative', width: '100%' }}>
                            <input
                                className={errorPassword && "input-error"}
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                style={{ width: '100%' }}
                                type={showPassword ? 'text' : 'password'}
                            />
                            <span
                                onClick={togglePasswordVisibility}
                                style={{
                                    position: 'absolute',
                                    right: '10px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    cursor: 'pointer',
                                }}
                            >
                                {showPassword ? <AiFillEyeInvisible /> : <AiFillEye />}
                            </span>
                        </div>
                        <p style={{ fontSize: '12px', fontFamily: 'inter', textAlign: 'right', color:'black' }}>
                            {formData.password.length}/10 caracteres
                        </p>
                        {errorPassword && <p style={{ fontSize: "10px", color: "rgb(228, 122, 122)", marginTop: "5px" }}>{errorPassword}</p>}
                    </div>
                    <div className="auth-content-input">
                        <p style={{ fontSize: '12px', fontFamily: 'inter', color:'black' }}>Repite la contraseña*</p>
                        <input
                            className={errorConfirmPassword && "input-error"}
                            name="password"
                            onChange={(e) => onChangeConfirmPassword(e)}
                            type="password"
                        />
                        {errorConfirmPassword && <p style={{ fontSize: "10px", color: "rgb(228, 122, 122)", marginTop: "5px" }}>{errorConfirmPassword}</p>}
                    </div>
                    <div className="auth-text">
                        <input type="checkbox" style={{ width: '5%', border: 0 }} />
                        <p className="" style={{ fontSize: "11px" , color:'black'}}>
                            He leído las {" "}<a style={{ color: "#EB0400", cursor: "pointer" }}>Reglas</a>{" "}
                            y estoy de acuerdo con ellas.
                        </p>
                    </div>
                    <div className="auth-content-input" style={{ marginTop: '10px' }}>
                        <ReCAPTCHA
                            sitekey="6LevISErAAAAAJF0OoqUgb6ogl_2F9Iph-B8S-oj"
                            onChange={(token) => setRecaptchaToken(token)}
                            onExpired={() => setRecaptchaToken(null)}
                        />
                        {!recaptchaToken && <p style={{ fontSize: "10px",  marginTop: "5px", color:'black' }}>Por favor, completa el reCAPTCHA</p>}
                    </div>
                    <button
                        onClick={handleCreateAccount}
                        className="auth-button-login"
                        
                    >
                        Crear cuenta
                    </button>
                </div>
            </Grid>
        </Nlayout>
    )
}

export default Crear